import {
  CREATE_BUSINESS_CLIENT_OPERATION,
  DELETE_BUSINESS_CLIENT_OPERATION,
  GET_BUSINESS_CLIENT_OPERATION,
  LIST_BUSINESS_CLIENTS_OPERATION,
  RESTORE_BUSINESS_CLIENT_OPERATION,
  UPDATE_BUSINESS_CLIENT_OPERATION,
  type GeneratedCreateBusinessClientRequest,
  type GeneratedCreateBusinessClientResponse,
  type GeneratedGetBusinessClientResponse,
  type GeneratedListBusinessClientsQuery,
  type GeneratedListBusinessClientsResponse,
  type GeneratedRestoreBusinessClientResponse,
  type GeneratedUpdateBusinessClientRequest,
  type GeneratedUpdateBusinessClientResponse,
} from './generated-business';
import {
  buildQueryString,
  performAuthorizedRequest,
  replacePathParams,
} from './business-request';

export async function listBusinessClientsRequest(
  token: string,
  businessId: number,
  query: Partial<GeneratedListBusinessClientsQuery> = {}
): Promise<GeneratedListBusinessClientsResponse> {
  return performAuthorizedRequest<GeneratedListBusinessClientsResponse>(
    token,
    {
      ...LIST_BUSINESS_CLIENTS_OPERATION,
      path:
        replacePathParams(LIST_BUSINESS_CLIENTS_OPERATION.path, {
          business_id: businessId,
        }) +
        buildQueryString({
          email: query.email,
          phone: query.phone,
          name: query.name,
          q: query.q,
          status: query.status,
          page: query.page,
          limit: query.limit,
        }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter os clientes. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível carregar os clientes agora.',
    }
  );
}

export async function getBusinessClientRequest(
  token: string,
  businessId: number,
  clientId: number
): Promise<GeneratedGetBusinessClientResponse> {
  return performAuthorizedRequest<GeneratedGetBusinessClientResponse>(
    token,
    {
      ...GET_BUSINESS_CLIENT_OPERATION,
      path: replacePathParams(GET_BUSINESS_CLIENT_OPERATION.path, {
        business_id: businessId,
        id: clientId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível obter o cliente. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível carregar o cliente agora.',
    }
  );
}

export async function createBusinessClientRequest(
  token: string,
  businessId: number,
  client: GeneratedCreateBusinessClientRequest
): Promise<GeneratedCreateBusinessClientResponse> {
  return performAuthorizedRequest<GeneratedCreateBusinessClientResponse>(
    token,
    {
      ...CREATE_BUSINESS_CLIENT_OPERATION,
      path: replacePathParams(CREATE_BUSINESS_CLIENT_OPERATION.path, {
        business_id: businessId,
      }),
    },
    {
      body: client,
      networkErrorMessage:
        'Não foi possível criar o cliente. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível criar o cliente agora.',
    }
  );
}

export async function updateBusinessClientRequest(
  token: string,
  businessId: number,
  clientId: number,
  client: GeneratedUpdateBusinessClientRequest
): Promise<GeneratedUpdateBusinessClientResponse> {
  return performAuthorizedRequest<GeneratedUpdateBusinessClientResponse>(
    token,
    {
      ...UPDATE_BUSINESS_CLIENT_OPERATION,
      path: replacePathParams(UPDATE_BUSINESS_CLIENT_OPERATION.path, {
        business_id: businessId,
        id: clientId,
      }),
    },
    {
      body: client,
      networkErrorMessage:
        'Não foi possível atualizar o cliente. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível atualizar o cliente agora.',
    }
  );
}

export async function deleteBusinessClientRequest(
  token: string,
  businessId: number,
  clientId: number
) {
  await performAuthorizedRequest(
    token,
    {
      ...DELETE_BUSINESS_CLIENT_OPERATION,
      path: replacePathParams(DELETE_BUSINESS_CLIENT_OPERATION.path, {
        business_id: businessId,
        id: clientId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível eliminar o cliente. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível eliminar o cliente agora.',
    }
  );
}

export async function restoreBusinessClientRequest(
  token: string,
  businessId: number,
  clientId: number
): Promise<GeneratedRestoreBusinessClientResponse> {
  return performAuthorizedRequest<GeneratedRestoreBusinessClientResponse>(
    token,
    {
      ...RESTORE_BUSINESS_CLIENT_OPERATION,
      path: replacePathParams(RESTORE_BUSINESS_CLIENT_OPERATION.path, {
        business_id: businessId,
        id: clientId,
      }),
    },
    {
      networkErrorMessage:
        'Não foi possível restaurar o cliente. Verifique se o backend está disponível.',
      requestErrorMessage: 'Não foi possível restaurar o cliente agora.',
    }
  );
}
